export interface LucideIconEntry {
  name: string;
  group: string;
  keywords: ReadonlyArray<string>;
}

export function lucideKebabToPascal(kebab: string): string {
  return kebab
    .split('-')
    .map((s) => (s.length > 0 ? s[0]!.toUpperCase() + s.slice(1) : ''))
    .join('');
}

export const LUCIDE_CATALOG: ReadonlyArray<LucideIconEntry> = [
  { name: 'utensils', group: 'food', keywords: ['餐具', '飲食', '吃飯', 'food', 'meal'] },
  { name: 'utensils-crossed', group: 'food', keywords: ['用餐', '餐廳', 'restaurant', 'dining'] },
  { name: 'coffee', group: 'food', keywords: ['咖啡', '飲料', 'coffee', 'drink'] },
  { name: 'cup-soda', group: 'food', keywords: ['飲料', '汽水', '手搖', 'soda', 'drink'] },
  { name: 'pizza', group: 'food', keywords: ['披薩', '比薩', 'pizza'] },
  { name: 'salad', group: 'food', keywords: ['沙拉', '蔬食', 'salad', 'vegetable'] },
  { name: 'sandwich', group: 'food', keywords: ['三明治', '早餐', 'sandwich', 'breakfast'] },
  { name: 'ice-cream', group: 'food', keywords: ['冰淇淋', '甜點', 'ice cream', 'dessert'] },
  { name: 'wine', group: 'food', keywords: ['紅酒', '酒類', 'wine', 'alcohol'] },
  { name: 'cookie', group: 'food', keywords: ['餅乾', '點心', 'cookie', 'snack'] },

  { name: 'car', group: 'transport', keywords: ['汽車', '開車', '計程車', 'car', 'taxi'] },
  { name: 'bus', group: 'transport', keywords: ['公車', '巴士', 'bus'] },
  { name: 'train', group: 'transport', keywords: ['火車', '高鐵', 'train'] },
  { name: 'plane', group: 'transport', keywords: ['飛機', 'plane', 'airplane'] },
  { name: 'bike', group: 'transport', keywords: ['腳踏車', '自行車', 'bike', 'bicycle'] },
  { name: 'tram-front', group: 'transport', keywords: ['捷運', '電車', 'tram', 'metro'] },
  { name: 'fuel', group: 'transport', keywords: ['加油', '油費', 'fuel', 'gas'] },
  { name: 'parking-circle', group: 'transport', keywords: ['停車', '停車費', 'parking'] },
  { name: 'wrench', group: 'transport', keywords: ['維修', '保養', 'wrench', 'maintenance'] },

  { name: 'home', group: 'home', keywords: ['首頁', '家', 'home'] },
  { name: 'house', group: 'home', keywords: ['房屋', '住宅', 'house'] },
  { name: 'bed-double', group: 'home', keywords: ['床', '家具', 'bed', 'furniture'] },
  { name: 'sofa', group: 'home', keywords: ['沙發', '家具', 'sofa', 'couch'] },
  { name: 'lightbulb', group: 'home', keywords: ['燈泡', '電費', 'light', 'bulb'] },
  { name: 'plug', group: 'home', keywords: ['插座', '電器', 'plug', 'electric'] },
  { name: 'wifi', group: 'home', keywords: ['網路', 'wifi', 'internet'] },
  { name: 'droplets', group: 'home', keywords: ['水費', '水', 'water'] },
  { name: 'flame', group: 'home', keywords: ['瓦斯', '火', 'gas', 'flame'] },

  { name: 'shirt', group: 'lifestyle', keywords: ['衣服', '服飾', 'shirt', 'clothing'] },
  { name: 'sparkles', group: 'lifestyle', keywords: ['美妝', '保養', 'beauty', 'sparkles'] },
  { name: 'scissors', group: 'lifestyle', keywords: ['美髮', '剪髮', 'scissors', 'hair'] },
  { name: 'smartphone', group: 'lifestyle', keywords: ['手機', '電信', 'phone', 'mobile'] },
  { name: 'tv', group: 'lifestyle', keywords: ['電視', '訂閱', 'tv', 'television'] },
  { name: 'headphones', group: 'lifestyle', keywords: ['耳機', '音樂', 'headphones', 'audio'] },
  { name: 'paint-roller', group: 'lifestyle', keywords: ['修繕', '油漆', 'paint', 'renovation'] },
  { name: 'bath', group: 'lifestyle', keywords: ['沐浴', '衛生用品', 'bath', 'toiletry'] },

  { name: 'gamepad', group: 'entertainment', keywords: ['遊戲', 'gamepad', 'game'] },
  { name: 'gamepad-2', group: 'entertainment', keywords: ['電玩', '遊戲機', 'gamepad', 'console'] },
  { name: 'film', group: 'entertainment', keywords: ['電影', 'film', 'movie'] },
  { name: 'music', group: 'entertainment', keywords: ['音樂', 'music'] },
  { name: 'disc', group: 'entertainment', keywords: ['唱片', '光碟', 'disc'] },
  { name: 'ticket', group: 'entertainment', keywords: ['票券', '門票', '演唱會', 'ticket'] },
  { name: 'sun', group: 'entertainment', keywords: ['戶外', '休閒', 'sun', 'outdoor'] },

  { name: 'heart', group: 'health', keywords: ['愛心', '健康', 'heart'] },
  { name: 'heart-pulse', group: 'health', keywords: ['心跳', '健檢', 'heartbeat', 'health check'] },
  { name: 'pill', group: 'health', keywords: ['藥品', '保健', 'pill', 'medicine'] },
  { name: 'stethoscope', group: 'health', keywords: ['看診', '醫療', 'stethoscope', 'doctor'] },
  { name: 'activity', group: 'health', keywords: ['運動', '健身', 'activity', 'fitness'] },
  { name: 'dumbbell', group: 'health', keywords: ['健身', '重訓', 'dumbbell', 'gym'] },
  { name: 'hospital', group: 'health', keywords: ['醫院', 'hospital'] },
  { name: 'brain', group: 'health', keywords: ['心理', '腦', 'brain', 'mental'] },

  { name: 'paw-print', group: 'pet', keywords: ['寵物', '腳印', 'pet', 'paw'] },
  { name: 'bone', group: 'pet', keywords: ['骨頭', '狗食', 'bone', 'dog food'] },
  { name: 'cat', group: 'pet', keywords: ['貓', 'cat'] },
  { name: 'dog', group: 'pet', keywords: ['狗', 'dog'] },
  { name: 'fish', group: 'pet', keywords: ['魚', '水族', 'fish'] },

  { name: 'plane-takeoff', group: 'travel', keywords: ['機票', '出國', 'flight', 'departure'] },
  { name: 'map-pin', group: 'travel', keywords: ['地點', '景點', 'location', 'pin'] },
  { name: 'map', group: 'travel', keywords: ['地圖', 'map'] },
  { name: 'camera', group: 'travel', keywords: ['相機', '拍照', 'camera'] },
  { name: 'luggage', group: 'travel', keywords: ['行李', '旅行箱', 'luggage'] },
  { name: 'tent', group: 'travel', keywords: ['露營', '帳篷', 'camping', 'tent'] },
  { name: 'mountain', group: 'travel', keywords: ['登山', '山', 'mountain', 'hiking'] },

  { name: 'wallet', group: 'finance', keywords: ['錢包', '收入', 'wallet'] },
  { name: 'credit-card', group: 'finance', keywords: ['信用卡', 'credit card'] },
  { name: 'banknote', group: 'finance', keywords: ['鈔票', '現金', 'banknote', 'cash'] },
  { name: 'coins', group: 'finance', keywords: ['硬幣', '零錢', 'coins'] },
  { name: 'piggy-bank', group: 'finance', keywords: ['儲蓄', '存錢', 'savings', 'piggy bank'] },
  { name: 'landmark', group: 'finance', keywords: ['銀行', '稅務', 'bank', 'landmark'] },
  { name: 'receipt', group: 'finance', keywords: ['收據', '發票', 'receipt'] },
  { name: 'trending-up', group: 'finance', keywords: ['上漲', '投資', 'trending up', 'profit'] },
  { name: 'trending-down', group: 'finance', keywords: ['下跌', '虧損', 'trending down', 'loss'] },
  { name: 'percent', group: 'finance', keywords: ['利率', '百分比', 'percent', 'rate'] },

  { name: 'briefcase', group: 'work', keywords: ['工作', '公事包', 'briefcase', 'work'] },
  { name: 'briefcase-business', group: 'work', keywords: ['薪資', '商務', 'business', 'salary'] },
  { name: 'graduation-cap', group: 'work', keywords: ['學費', '畢業', 'graduation', 'tuition'] },
  { name: 'book-open', group: 'work', keywords: ['書本', '課程', 'book', 'course'] },
  { name: 'book', group: 'work', keywords: ['書', '閱讀', 'book', 'reading'] },
  { name: 'building', group: 'work', keywords: ['公司', '辦公室', 'building', 'office'] },
  { name: 'laptop', group: 'work', keywords: ['筆電', '工作', 'laptop'] },

  { name: 'gift', group: 'misc', keywords: ['禮物', '送禮', 'gift'] },
  { name: 'cake', group: 'misc', keywords: ['生日', '蛋糕', 'cake', 'birthday'] },
  { name: 'star', group: 'misc', keywords: ['星星', '收藏', 'star', 'favorite'] },
  { name: 'cloud', group: 'misc', keywords: ['雲端', 'cloud'] },
  { name: 'bell', group: 'misc', keywords: ['鈴鐺', '通知', 'bell', 'notification'] },
  { name: 'tag', group: 'misc', keywords: ['標籤', '其他', 'tag', 'label'] },
  { name: 'calendar', group: 'misc', keywords: ['行事曆', '日期', 'calendar', 'date'] },
  { name: 'clock', group: 'misc', keywords: ['時間', '時鐘', 'clock', 'time'] },
  { name: 'sticky-note', group: 'misc', keywords: ['筆記', '備註', 'note', 'memo'] },
  { name: 'refresh-cw', group: 'misc', keywords: ['循環', '訂閱', 'refresh', 'recurring'] },
];
